import { useLayoutEffect, useRef, type ReactNode } from 'react'

/** Keep floating actions inside the scene; compact lists scroll them in normal flow. */
export function SceneMenu({ id, label, children }: { id: string; label: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    const menu = ref.current!, mark = menu.parentElement!, scene = menu.closest('.location')!
    const measure = () => {
      const s = scene.getBoundingClientRect(), m = mark.getBoundingClientRect()
      const height = Math.min(menu.scrollHeight + 2, Math.max(44, s.height - 24))
      const top = Math.max(s.top + 12, Math.min(m.bottom - 30, s.bottom - height - 12))
      menu.style.setProperty('--menu-top', `${top - m.top}px`)
      menu.style.setProperty('--menu-max-height', `${Math.max(44, s.height - 24)}px`)
    }
    const ro = new ResizeObserver(measure)
    ro.observe(scene); ro.observe(mark); ro.observe(menu)
    window.addEventListener('resize', measure)
    measure()
    return () => { ro.disconnect(); window.removeEventListener('resize', measure) }
  }, [])
  return <div ref={ref} className="markmenu slab" id={id} role="menu" aria-label={label}>{children}</div>
}
